import { CSSObject } from "@emotion/react";
import {
  AnchorStyleOverrides,
  AngelouCSS,
  constants,
  typographyStyles,
} from "@newsela/angelou";

export const relativeContainerCss: CSSObject = {
  position: "relative",
  borderRadius: "0.5rem",

  ":hover": {
    background: constants.colors.ui.neutral[500],
  },
};

export const rowContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "1rem",
  gap: "0.25rem",
};

export const rowAnchorCss: AnchorStyleOverrides<AngelouCSS> = {
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    textDecoration: "none",
  },
};

export const titleFlexRowCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  gap: "0.5rem",
  alignItems: "center",

  "div + svg": {
    marginBottom: "0.225rem",
  },
};

export const titleCss = {
  ...typographyStyles.fontSize.heading3,
  ...typographyStyles.lineHeight.heading5LineHeights,
  fontWeight: 700,
  color: constants.colors.ui.white[50],
};

export const externalLinkIconCss = {
  root: {
    width: "1rem",
    height: "1rem",

    path: {
      stroke: constants.colors.ui.white[50],
    },
  },
};

export const descriptionCss = {
  lineHeight: "1.25rem",
  color: constants.colors.ui.white[50],
};
